import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import BackdropHlsAdjustmentAlphaListItem from './BackdropHlsAdjustmentAlphaListItem';
import BackdropHlsAdjustmentHueListItem from './BackdropHlsAdjustmentHueListItem';
import BackdropHlsAdjustmentSaturationListItem from './BackdropHlsAdjustmentSaturationListItem';
import BackdropAdjustmentColorizeListItem from './BackdropHlsAdjustmentColorizeListItem';
import BackdropAdjustmentLightnessListItem from './BackdropHlsAdjustmentLightnessListItem';

const BackdropHlsAdjustmentListItem = (props) => {
    const { updateBackgroundSettings, hlsAdjustmentEnabled } = props;
    const onEnabledChange = (value) => updateBackgroundSettings({ hlsAdjustment: { enabled: value } });

    return (
        <CollapsibleSwitchListItem
            checked={hlsAdjustmentEnabled}
            text='Adjust'
            onChange={onEnabledChange}
            expansionEnabled={true}
        >
            <List
                dense
                disablePadding
            >
                <BackdropHlsAdjustmentHueListItem />

                <BackdropHlsAdjustmentSaturationListItem />

                <BackdropAdjustmentLightnessListItem />

                <BackdropAdjustmentColorizeListItem />

                <BackdropHlsAdjustmentAlphaListItem />
            </List>
        </CollapsibleSwitchListItem>
    );
}

const mapStateToProps = (state) => {
    const hlsAdjustmentEnabled = state.createPreview.present.videoSettings.background.hlsAdjustment.enabled;
    return { hlsAdjustmentEnabled }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropHlsAdjustmentListItem);